/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetCasesResponseJson } from './get-cases-response-json';
import { GetCasesResult } from '../results/get-cases-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { CaseDto } from '../models/case-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetCasesResponse extends ResponseWithErrorGeneric<GetCasesResponseJson, GetCasesResult> implements IResponseWithErrorGeneric<GetCasesResult> {
  public cases: CaseDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetCasesResponse>) {
    super(response, GetCasesResult.Error);
    if (this.result !== GetCasesResult.Success) {
      return;
    }

    this.cases = this.body.cases ? this.body.cases.map(c => new CaseDto(c)) : [];
  }
  //</custom-body>
}
